import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import SingleClientQuestionnaires from "./FindyourClient(s)/SingleClientQuestionnaires";
import FindyourClientsTab from "./FindyourClient(s)/FindyourClientsTab";
import UseClientcode from "./UseClientcode";
import RenewPrequilification from "./RenewPrequilification";
import { use } from "i18next";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function ClientQuestionnaireTab() {
  const params = new URLSearchParams(window.location.search);
  const Vendor = params.get("Vendor");
  const TypeIdx = Number(params.get("TypeIdx"));

  const [value, setValue] = React.useState(TypeIdx ? TypeIdx : 0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    // URL TypeIdx cleanup
    params.delete("TypeIdx");
    window.history.replaceState(
      {},
      "",
      `${window.location.pathname}?${params.toString()}`
    );
  }, []);


  return (
    <>
      <Tabs
        className=""
        value={value}
        onChange={handleChange}
        variant="scrollable"
      >
        <Tab
          label="Find your Client(s)"
          sx={{ marginLeft: 3 }}
          {...a11yProps(0)}
          style={{ textTransform: "inherit" }}
        />
        <Tab
          label="Use a Client Code"
          {...a11yProps(1)}
          style={{ textTransform: "inherit" }}
        />
        <Tab
          label="Renew Prequalification"
          {...a11yProps(2)}
          style={{ textTransform: "inherit" }}
        />
      </Tabs>
      <TabPanel value={Number(value)} index={0}>
        <FindyourClientsTab Vendid={Vendor} />
      </TabPanel>

      <TabPanel value={Number(value)} index={1}>
        <UseClientcode Vendid={Vendor} />
      </TabPanel>
      <TabPanel value={Number(value)} index={2}>
        {/* <Box  border={1}
          borderLeft={1}
          borderRight={1}
          borderColor="#e4e7ec" sx={{padding:"20px"}}>
        <SingleClientQuestionnaires/>
        </Box> */}

        <RenewPrequilification Vendid={Vendor} />
      </TabPanel>
    </>
  );
}
